import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Accordion,
  CloseButton,
  Form,
  ListGroup,
  Modal,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
// import CustomDatePicker from "./DatePicker";
import Footer from "./Footer.js";
import NewHeader from "./newHeader.js";
import Stepper from "./Stepper";
import FixedBottomSummary from "./components/_FixedBottomSummary";
import * as myConstClass from "./constant.js";
import { BASE_URL } from "./constant.js";
import "./eventDetails.css";
import {
  getCartTotalPriceAsync,
  manageHasEventsAsync,
  resetMachineTestMode,
  selectCheckoutSteps,
  selectTncEventsChecked,
  setNormalEventSteps,
  setMachineTestSteps,
  stepsEnum,
} from "./store/checkoutSlice";
import "./styles/bs-accordion.css";
import "./styles/bs-button.css";
import "./styles/bs-overrides.css";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { DatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

const EventDetails = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const checkoutSteps = useSelector(selectCheckoutSteps);
  const tncEventsChecked = useSelector(selectTncEventsChecked);

  const bottomSummaryRef = useRef(null);

  // NEW: State for dynamically calculated event price based on participants
  const [calculatedEventPrice, setCalculatedEventPrice] = useState(0);
  const [eventPricePerPerson, setEventPricePerPerson] = useState(0);

  const [fullName, setFullName] = useState("");
  const [gender, setGender] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState(null);
  // Control open state for DOB DatePicker so Enter key can open it when focused
  const [dobOpen, setDobOpen] = useState(false);
  const [enableSave, setEnableSave] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const [persons, setPersons] = useState([]);
  const [eventsData, setEventsData] = useState([]);
  const [active, setActive] = useState("");
  const [schedule_id, setSchedule_id] = useState(null);
  const [event_id, setEvent_id] = useState(null);

  const [isAgreed, setIsAgreed] = useState(false);

  const [showModal, setShowModal] = useState(false);

  // State for selected persons of all events.
  const [activeEventParticipants, setActiveEventParticipants] = useState([]);

  // State for participant types (participant_id -> type)
  const [participantTypes, setParticipantTypes] = useState({});
  
  // State for available participant type options (based on event pricing)
  const [availableParticipantTypes, setAvailableParticipantTypes] = useState([]);

  // Initialize participant types from localStorage so dropdowns reflect previously
  // selected types (prevents the dropdowns from appearing to block selection)
  useEffect(() => {
    try {
      const stored = JSON.parse(localStorage.getItem('selected_participant_types') || '{}');
      if (stored && typeof stored === 'object' && Object.keys(stored).length > 0) {
        setParticipantTypes(prev => ({ ...stored, ...prev }));
      }
    } catch (err) {
    }
  }, []);

  // State for age range validation
  const [minAge, setMinAge] = useState(null);
  const [maxAge, setMaxAge] = useState(null);
  const [ageValidationError, setAgeValidationError] = useState("");

  useEffect(() => {
    const user_id = localStorage.getItem("user_id");
    const guestAllowed = localStorage.getItem('guest_allowed') === 'true';

    if (!user_id && !guestAllowed) {
      // Guest user not allowed -> store return path and redirect to signin
      localStorage.setItem('redirect_after_login', window.location.pathname);
      history.replace('/signin');
      return;
    }
    
    if (user_id) {
      localStorage.removeItem("error");
    }

    // Clear the cart proceeding flag since we successfully reached eventDetails
    localStorage.removeItem('cart_proceeding_to_checkout');
    
    // Mark that event checkout is in progress
    // This will be cleared when payment is successful
    localStorage.setItem('event_checkout_in_progress', 'true');
    // Clear the proceeding flag when component mounts (in case it was set before)
    localStorage.removeItem('event_checkout_proceeding');
    // Clear editing participants flag when returning to eventDetails
    localStorage.removeItem('editing_participants');

    // Cleanup function: Clear booking event if user backs out during checkout
    return () => {
      // Check immediately if we should skip cleanup
      const isProceedingToNext = localStorage.getItem('event_checkout_proceeding');
      const checkoutInProgress = localStorage.getItem('event_checkout_in_progress');
      const isEditingParticipants = localStorage.getItem('editing_participants');
      const currentPath = window.location.pathname;
      
      // Don't cleanup if:
      // 1. User is proceeding to next page
      // 2. Checkout is not in progress (completed)
      // 3. Still on eventDetails page (might be a re-render)
      // 4. User is navigating to participants page to edit/add participants
      if (isProceedingToNext === 'true' || 
          checkoutInProgress !== 'true' || 
          currentPath === '/eventDetails' ||
          currentPath === '/participants' ||
          isEditingParticipants === 'true') {
        return;
      }

      // Only cleanup if user actually navigated away
      
      // Use a small delay to ensure this is a real navigation, not a re-render
      const timeoutId = setTimeout(() => {
        // Double-check we're not on eventDetails or participants page anymore
        const finalPath = window.location.pathname;
        const finalEditingFlag = localStorage.getItem('editing_participants');
        
        if (finalPath === '/eventDetails' || 
            finalPath === '/participants' || 
            finalEditingFlag === 'true') {
          return;
        }
        
        // User backed out - clear booking event
        
        const userId = localStorage.getItem("user_id");
        
        if (userId && userId > 0) {
          localStorage.removeItem('booking_event');
        } else {
          localStorage.removeItem('booking_event_guest');
        }
        
        // Clear participant data
        localStorage.removeItem('guest_event_participants');
        localStorage.removeItem('guest_participants');

        // Clear the checkout flags
        localStorage.removeItem('event_checkout_in_progress');
        localStorage.removeItem('event_checkout_proceeding');
        
        // Cleanup: revoke guest access so future entries force login
        if (localStorage.getItem('guest_allowed')) {
          localStorage.removeItem('guest_allowed');
        }
      }, 500);
      
      // Clear timeout if component remounts quickly (re-render scenario)
      return () => {
        clearTimeout(timeoutId);
      };
    };
  }, [history]);

  useEffect(() => {
    // Check if booking_event exists to set appropriate steps
    const checkAndSetSteps = async () => {
      const user_id = localStorage.getItem("user_id");
      let bookingEvent = null;
      
      if (user_id && user_id > 0) {
        const bookingEventStr = localStorage.getItem('booking_event');
        if (bookingEventStr) {
          bookingEvent = JSON.parse(bookingEventStr);
        }
      } else {
        const bookingEventStr = localStorage.getItem('booking_event_guest');
        if (bookingEventStr) {
          bookingEvent = JSON.parse(bookingEventStr);
        }
      }
      
      if (bookingEvent) {
        // Check if it's a machine test
        const isMachineTest = bookingEvent.event_type === 'Machine Test' || bookingEvent.event_type_id === 3;
        
        if (isMachineTest) {
          dispatch(setMachineTestSteps());
        } else {
          dispatch(setNormalEventSteps());
        }
      } else {
        dispatch(setNormalEventSteps());
      }
    };
    
    checkAndSetSteps();
    dispatch(getCartTotalPriceAsync());
    dispatch(manageHasEventsAsync());
    loadEvents();
    loadParticipants();
    
    // Cleanup function to reset modes when component unmounts
    return () => {
      dispatch(resetMachineTestMode());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  function handleConfirmation() {
    // windows, android & evertyhing normal
    const url = "TnCEvents.pdf";
    const link = document.createElement("a");
    link.rel = "noopener noreferrer";
    link.href = url;
    link.target = "_blank";
    link.download = "Terms & Conditions for Events.pdf";
    document.body.appendChild(link);
    link.click();

    // ios workaround
    // window.open(url, "_blank", "popup");
    window.open(url, "_blank", "toolbar=no,location=no,status=no,menubar=no");

    // history.push("/address");
    // const _location = new URL(window.location)
    // window.history.pushState({}, null, "/address");
    // window.history.replaceState({}, null, "/address");
    // window.location.href = "/address";
  }

  const loadEvents = useCallback(async function loadEvents() {
    try {
      const user_id = localStorage.getItem("user_id");
      
      // NEW: Read from booking_event / booking_event_guest instead of cart
      let bookingEvent = null;
      
      if (user_id && user_id > 0) {
        // Logged-in user: first try booking_event
        let bookingEventStr = localStorage.getItem('booking_event');
        
        // If not found (e.g. user just logged in after selecting as guest),
        // fall back to booking_event_guest and promote it to booking_event
        if (!bookingEventStr) {
          const guestBookingStr = localStorage.getItem('booking_event_guest');
          if (guestBookingStr) {
            bookingEventStr = guestBookingStr;
            // Promote guest booking to logged-in booking for subsequent steps
            localStorage.setItem('booking_event', bookingEventStr);
            localStorage.removeItem('booking_event_guest');
          }
        }

        if (bookingEventStr) {
          bookingEvent = JSON.parse(bookingEventStr);
        }
      } else {
        // Guest user: read from booking_event_guest
        const bookingEventStr = localStorage.getItem('booking_event_guest');
        if (bookingEventStr) {
          bookingEvent = JSON.parse(bookingEventStr);
        }
      }
      
      if (bookingEvent) {
        // Transform booking event to match the expected format
        const transformedEvents = [{
          arr_cart: [{
            event_id: bookingEvent.event_id,
            schedule_id: bookingEvent.schedule_id,
            title: bookingEvent.title,
            title_mr: bookingEvent.title_mr,
            price: bookingEvent.price,
            child_price: bookingEvent.child_price,
            event_type: bookingEvent.event_type,
            event_type_id: bookingEvent.event_type_id,
            parent: bookingEvent.parent,
            child: bookingEvent.child,
            image: bookingEvent.image,
            start_date: bookingEvent.start_date,
            end_date: bookingEvent.end_date,
            venue: bookingEvent.venue,
            first_price_for: bookingEvent.first_price_for || 'Person',
            second_price_for: bookingEvent.second_price_for || null,
            minAge: bookingEvent.minAge || null,
            maxAge: bookingEvent.maxAge || null,
            selected_at: bookingEvent.selected_at
          }]
        }];
        
        setEventsData(transformedEvents);

        setActive(bookingEvent.event_id ?? null);
      } else {
        setEventsData([]);
        setActive(null);
        // Redirect back if no event to book
        toast.error('No event selected for booking. Please select an event first.');
        setTimeout(() => {
          history.push('/events');
        }, 2000);
      }
    } catch (error) {
    }
  }, [history, setEventsData, setActive]);

  const loadParticipants = useCallback(async function loadParticipants() {
    try {
      const user_id = localStorage.getItem("user_id");
      
      if (user_id && user_id > 0) {
        // Logged-in user flow - load from API
        // This will be handled by the existing API calls in the component
      } else {
        // Guest user flow - load from localStorage
        const guestParticipants = JSON.parse(localStorage.getItem('guest_participants') || '[]');
        setPersons(guestParticipants);
      }
    } catch (error) {
    }
  }, []);

  // Restore selected participants from localStorage after participants are loaded
  useEffect(() => {
    if (persons.length > 0) {
      try {
        const selectedIds = JSON.parse(localStorage.getItem('event_selected_participant_ids') || '[]');
        
        if (selectedIds.length > 0) {
          // Find matching participant objects by ID
          const selectedParticipants = persons.filter(p => 
            selectedIds.includes(p.participant_id)
          );
          
          if (selectedParticipants.length > 0) {
            // Only restore if all selected participants are still available
            if (selectedParticipants.length === selectedIds.length) {
              setActiveEventParticipants(selectedParticipants);
              
            } else {
              // Some selected participants are no longer available, clear the selection
              localStorage.removeItem('event_selected_participant_ids');
              setActiveEventParticipants([]);
            }
          }
        }
      } catch (err) {
        localStorage.removeItem('event_selected_participant_ids');
      }
    }
  }, [persons]);

  // Clear selected participants from localStorage when navigating away from event details
  useEffect(() => {
    return () => {
      // Only clear if not navigating to editing or proceeding to next step
      const isNavigatingToEdit = localStorage.getItem('editing_participants') === 'true';
      const isProceedingToNext = localStorage.getItem('event_checkout_proceeding') === 'true';
      
      if (!isNavigatingToEdit && !isProceedingToNext) {
        localStorage.removeItem('event_selected_participant_ids');
      }
      
      // Always clear the proceeding flag (will be reset if needed on next navigation)
      setTimeout(() => {
        localStorage.removeItem('event_checkout_proceeding');
      }, 100);
    };
  }, []);

  // Calculate age in years from date of birth
  const calculateAgeInYears = useCallback((birthDate) => {
    if (!birthDate) return null;
    
    const dob = new Date(birthDate);
    const today = new Date();
    
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    
    // Adjust age if birthday hasn't occurred this year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    
    return age;
  }, []);

  // Validate existing participant's age (for saved participants)
  const validateParticipantAge = useCallback((participant) => {
    if (!participant) return false;
    
    // If age range is not loaded yet, or admin explicitly set both min and max to 0
    // (which we treat as "no restriction"), allow selection
    if (minAge === null || maxAge === null || (minAge === 0 && maxAge === 0)) {
      return true;
    }
    
    // Get birth date from participant (could be birth_date, birthDate, or other field)
    const birthDate = participant.birth_date || participant.birthDate || participant.date_of_birth;
    
    if (!birthDate) {
      // No birth date available, can't validate - allow selection but warn
      return true;
    }
    
    const age = calculateAgeInYears(birthDate);
    
    if (age === null) {
      return true;
    }
    
    if (age < minAge || age > maxAge) {
      return false;
    }
    
    return true;
  }, [minAge, maxAge, calculateAgeInYears]);

  // Fetch age range from API
  const fetchAgeRange = useCallback(async (eventId) => {
    try {
      // Use NODE_API_BASE for the Node API endpoint
      const apiBase = myConstClass.NODE_API_BASE || BASE_URL.replace('/index.php/', '/api');
      const ageRangeUrl = `${apiBase}/event/getAgeRange/${eventId}`;
      
      const response = await fetch(ageRangeUrl);
      const data = await response.json();
      
      if (data?.status === 'true' && data?.data) {
        setMinAge(data.data.minAge);
        setMaxAge(data.data.maxAge);
      }
    } catch (error) {
    }
  }, []);

  // Unified participant loader for both schedule and machine test events
  const loadExistingParticipants = useCallback(async function loadExistingParticipants() {
    try {
      const user_id = localStorage.getItem("user_id");

      // No request if not logged in; guests manage participants locally
      if (!user_id || Number(user_id) <= 0) {
        return;
      }

      // Use Node.js API to get all user participants
      const nodeApiBase = myConstClass.NODE_API_BASE || BASE_URL.replace('/index.php/', '/api');
      const participantsUrl = `${nodeApiBase}/participants/getUserParticipants/${user_id}`;
      
      const response = await fetch(participantsUrl);
      const participantsReqData = await response.json();
      
      // Handle both response formats (data in .data or root level)
      const participantsArray = participantsReqData?.data || participantsReqData;
      
      setPersons(Array.isArray(participantsArray) ? participantsArray.reverse() : []);
      // Use all participants returned from API (do not restrict to participants_temp_id)
      const participantsList = Array.isArray(participantsReqData)
        ? participantsReqData
        : [];

      // Validate against age range if available
      const validatedParticipants = participantsList.filter((participant) => {
        // If age range is not loaded yet or explicitly set to 0-0 (no restriction), skip validation
        if (minAge === null || maxAge === null || (minAge === 0 && maxAge === 0)) return true;
        return validateParticipantAge(participant);
      });
      
      // Auto-select participant type for ALL loaded participants if only one type is available
      // BUT only if this is the initial load (persons array is empty or has fewer items)
      const isInitialLoad = persons.length === 0 || validatedParticipants.length > persons.length;
      if (availableParticipantTypes.length === 1 && validatedParticipants.length > 0 && isInitialLoad) {
        const autoSelectedType = availableParticipantTypes[0].value;
        setParticipantTypes(prev => {
          const updated = { ...prev };
          validatedParticipants.forEach(participant => {
            // Only auto-select if not already set
            if (!updated[participant.participant_id]) {
              updated[participant.participant_id] = autoSelectedType;
            }
          });
          return updated;
        });
      }

      // Instead of auto-selecting ALL validated participants (which was causing
      // types/select state to appear blocked or inconsistent), only pre-select
      // participants that were previously saved for this event (if any).
      // This prevents unexpected auto-selection and preserves user choices.
      try {
        const eventKey = schedule_id ? `schedule_${schedule_id}` : `event_${event_id}`;
        const loggedInSelections = JSON.parse(localStorage.getItem('logged_in_event_participants') || '{}');
        const guestSelections = JSON.parse(localStorage.getItem('guest_event_participants') || '{}');

        let preSelectedIds = [];
        const user_id = localStorage.getItem('user_id');

        if (user_id && user_id > 0) {
          preSelectedIds = Array.isArray(loggedInSelections[eventKey]) ? loggedInSelections[eventKey] : [];
        } else {
          // guestSelections stores objects with participant_id keys
          const guestForEvent = guestSelections[eventKey] || [];
          preSelectedIds = guestForEvent.map(p => p.participant_id);
        }

        // Build the pre-selected participant objects only from validated participants
        const preSelectedParticipants = validatedParticipants.filter(p => preSelectedIds.includes(p.participant_id));

        // If there are no prior selections, do not auto-select anything — leave empty selection
        setActiveEventParticipants(preSelectedParticipants);

        // Warn if any got filtered out by age validation
        if (
          minAge !== null &&
          maxAge !== null &&
          validatedParticipants.length < participantsList.length
        ) {
          const filteredCount = participantsList.length - validatedParticipants.length;
          toast(
            `${filteredCount} participant(s) were automatically removed because they are outside the age range (${minAge}-${maxAge} years).`,
            {
              containerId: "B",
              type: toast.TYPE.WARNING,
            }
          );
        }
      } catch (err) {
        // Fallback: keep no active selections
        setActiveEventParticipants([]);
      }
    } catch (error) {
    }
  }, [minAge, maxAge, validateParticipantAge, availableParticipantTypes]);

  useEffect(() => {
    if (!active) {
      return;
    }
    
    if (!eventsData || eventsData.length === 0) {
      return;
    }
    
    let _allEvents = [...eventsData];
    _allEvents = _allEvents.map((eg) => eg.arr_cart).flat();
    const _event = _allEvents.find((e) => e.event_id === active);
    
    setEvent_id(_event?.event_id ?? null);
    setSchedule_id(_event?.schedule_id ?? null);
    
    // Set available participant types based on event pricing structure
    if (_event) {
      const types = [];
      if (_event.first_price_for) {
        types.push({
          value: _event.first_price_for.toLowerCase(),
          label: _event.first_price_for,
          price: parseFloat(_event.price || 0)
        });
      }
      if (_event.second_price_for && _event.child_price) {
        types.push({
          value: _event.second_price_for.toLowerCase(),
          label: _event.second_price_for,
          price: parseFloat(_event.child_price || 0)
        });
      }
      setAvailableParticipantTypes(types);
    }
  }, [active, eventsData]);

  useEffect(() => {
    if (event_id) {
      // Fetch age range and then load participants from correct source
      fetchAgeRange(event_id);
      loadExistingParticipants();
    }
  }, [event_id, schedule_id, fetchAgeRange, loadExistingParticipants]);

  // Validate age against min/max age range (for new participants)
  const validateAge = useCallback((birthDate) => {
    if (!birthDate) {
      setAgeValidationError("");
      return true;
    }
    
    // If age range is not loaded yet, skip validation
    // Also treat min=0 and max=0 as no restriction
    if (minAge === null || maxAge === null || (minAge === 0 && maxAge === 0)) {
      setAgeValidationError("");
      return true;
    }
    
    const age = calculateAgeInYears(birthDate);
    
    if (age === null) {
      setAgeValidationError("");
      return true;
    }
    
    if (age < minAge) {
      setAgeValidationError(`Age must be at least ${minAge} years. Current age: ${age} years.`);
      return false;
    }
    
    if (age > maxAge) {
      setAgeValidationError(`Age must not exceed ${maxAge} years. Current age: ${age} years.`);
      return false;
    }
    
    setAgeValidationError("");
    return true;
  }, [minAge, maxAge, calculateAgeInYears]);

  const calculateAge = (birthDate) => {
    var dob = new Date(birthDate);
    var currentDate = new Date();

    // Do This with date-fns formatDistance
    // better to use standard library that doing own calc

    var ageInMilliseconds = currentDate - dob;

    // Average days in a month
    var ageInMonths = Math.floor(
      ageInMilliseconds / (30.44 * 24 * 60 * 60 * 1000)
    );

    if (ageInMonths < 12) {
      if (ageInMonths === 1) {
        return `${ageInMonths} Month`;
      } else {
        return `${ageInMonths} Months`;
      }
    } else {
      var ageInYears = Math.floor(ageInMonths / 12);
      if (ageInYears === 1) {
        return `${ageInYears} Year`;
      } else {
        return `${ageInYears} Years`;
      }
    }
  };

  useEffect(() => {
    // Enable save only if required fields are filled (DOB is optional)
    const hasAllFields = fullName && gender;
    const ageIsValid = !ageValidationError && (dateOfBirth ? validateAge(dateOfBirth) : true);
    if (hasAllFields && ageIsValid) {
      setEnableSave(true);
    } else {
      setEnableSave(false);
    }
  }, [fullName, gender, dateOfBirth, ageValidationError, minAge, maxAge, validateAge]);

  const saveParticipant = async (event) => {
    event.preventDefault();
    const user_id = localStorage.getItem("user_id");

    let _dateOfBirth = null;
    if (dateOfBirth) {
      // Validate age before saving if DOB is provided
      if (!validateAge(dateOfBirth)) {
        toast(ageValidationError, {
          containerId: "B",
          type: toast.TYPE.ERROR,
        });
        return;
      }
      _dateOfBirth = dateOfBirth.toISOString().split("T")[0];
    }

    try {
      if (user_id && user_id > 0) {
        // Logged-in user flow - use Node.js API
        const nodeApiBase = myConstClass.NODE_API_BASE || BASE_URL.replace('/index.php/', '/api');
        const addParticipantUrl = `${nodeApiBase}/participants/addParticipants/${user_id}`;
        
        // Convert to Node API format
        const participantData = {
          participate_first_name: fullName,
          participate_gender: gender,
          birth_date: _dateOfBirth,
          participate_mobile: "" // Optional field
        };
        
        const addParticipantsData = await (
          await fetch(addParticipantUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(participantData),
          })
        ).json();

        if (addParticipantsData.status === "true" || addParticipantsData.status === true) {
          toast("" + (addParticipantsData?.message || "Participant added successfully"), {
            containerId: "B",
            type: toast.TYPE.SUCCESS,
          });

          const _existing = persons.map((el) => el.participant_id);

          // Reload participants using Node API
          const nodeApiBase = myConstClass.NODE_API_BASE || BASE_URL.replace('/index.php/', '/api');
          const participantsUrl = `${nodeApiBase}/participants/getUserParticipants/${user_id}`;
          const response = await fetch(participantsUrl);
          const participantsReqData = await response.json();
          const participantsArray = participantsReqData?.data || participantsReqData;

          setPersons(Array.isArray(participantsArray) ? participantsArray.reverse() : []);
          
          const newAdded = (Array.isArray(participantsArray) ? participantsArray : []).filter(
            (el) => !_existing.includes(el.participant_id)
          );

          // Only add new participants to selection, keep existing selection intact
          setActiveEventParticipants([...activeEventParticipants, ...newAdded]);
          
          // Auto-select participant type ONLY for newly added participants
          if (availableParticipantTypes.length === 1 && newAdded.length > 0) {
            const autoSelectedType = availableParticipantTypes[0].value;
            setParticipantTypes(prev => {
              const updated = { ...prev };
              newAdded.forEach(participant => {
                updated[participant.participant_id] = autoSelectedType;
              });
              return updated;
            });
          }
          
          setFormSubmitted(true);

          setFullName("");
          setGender("");
          setDateOfBirth(null);
          setEnableSave(false);
          setFormSubmitted(false);
        } else {
          toast("" + (addParticipantsData?.message || "Failed to add participant"), {
            containerId: "B",
            type: toast.TYPE.ERROR,
          });
        }
      } else {
        // Guest user flow - store in localStorage
        const guestParticipants = JSON.parse(localStorage.getItem('guest_participants') || '[]');
        
        const newParticipant = {
          participant_id: `guest_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
          participate_first_name: fullName,
          participate_gender: gender,
          birth_date: _dateOfBirth,
          participate_age: _dateOfBirth ? calculateAge(_dateOfBirth) : '',
          added_at: new Date().toISOString()
        };
        
        guestParticipants.push(newParticipant);
        localStorage.setItem('guest_participants', JSON.stringify(guestParticipants));
        
        toast("Participant added successfully!", {
          containerId: "B",
          type: toast.TYPE.SUCCESS,
        });

        setPersons((prev) => [...prev, newParticipant]);
        setActiveEventParticipants([...activeEventParticipants, newParticipant]);
        
        // Auto-select participant type if only one type is available
        if (availableParticipantTypes.length === 1) {
          const autoSelectedType = availableParticipantTypes[0].value;
          setParticipantTypes(prev => ({
            ...prev,
            [newParticipant.participant_id]: autoSelectedType
          }));
        }
        
        setFormSubmitted(true);

        setFullName("");
        setGender("");
        setDateOfBirth(null);
        setEnableSave(false);
        setFormSubmitted(false);
      }
    } catch (error) {
      toast("Error saving participant", {
        containerId: "B",
        type: toast.TYPE.ERROR,
      });
    }
  };


  const handlePersonSelect = (selectedPerson, isSelected) => {
    if (isSelected) {
      // Validate age before allowing selection
      if (!validateParticipantAge(selectedPerson)) {
        const age = calculateAgeInYears(selectedPerson.birth_date || selectedPerson.birthDate || selectedPerson.date_of_birth);
        toast(
          `Cannot select ${selectedPerson.participate_first_name || selectedPerson.first_name || 'this participant'}. Age ${age} is outside the allowed range (${minAge}-${maxAge} years).`,
          {
            containerId: "B",
            type: toast.TYPE.ERROR,
          }
        );
        return; // Don't add to selection
      }
      const updatedParticipants = [...activeEventParticipants, selectedPerson];
      setActiveEventParticipants(updatedParticipants);
      
      // Persist selected participant IDs to localStorage
      const selectedIds = updatedParticipants.map(p => p.participant_id);
      localStorage.setItem('event_selected_participant_ids', JSON.stringify(selectedIds));
      
      // Auto-select participant type if only one type is available
      if (availableParticipantTypes.length === 1) {
        const participantId = selectedPerson.participant_id;
        const autoSelectedType = availableParticipantTypes[0].value;
        setParticipantTypes(prev => ({
          ...prev,
          [participantId]: autoSelectedType
        }));
      }
    } else {
      const updatedParticipants = activeEventParticipants.filter(
        (person) => person.participant_id !== selectedPerson.participant_id
      );
      setActiveEventParticipants(updatedParticipants);
      
      // Persist updated selected participant IDs to localStorage
      const selectedIds = updatedParticipants.map(p => p.participant_id);
      localStorage.setItem('event_selected_participant_ids', JSON.stringify(selectedIds));
    }
  };


  async function handleProceed() {
    try {
      // Mark that we're proceeding to next step (to prevent clearing selected participants)
      localStorage.setItem('event_checkout_proceeding', 'true');
      const user_id = localStorage.getItem("user_id");

      // Validate all selected participants before proceeding
      if (minAge !== null && maxAge !== null) {
        const invalidParticipants = activeEventParticipants.filter(
          participant => !validateParticipantAge(participant)
        );
        
        if (invalidParticipants.length > 0) {
          const invalidNames = invalidParticipants.map(p => 
            p.participate_first_name || p.first_name || 'Unknown'
          ).join(', ');
          
          toast(
            `Cannot proceed. The following participants are outside the age range (${minAge}-${maxAge} years): ${invalidNames}. Please remove them or select different participants.`,
            {
              containerId: "B",
              type: toast.TYPE.ERROR,
            }
          );
          return;
        }
      }

      // Check if at least one participant is selected
      if (activeEventParticipants.length === 0) {
        toast("Please select at least one participant before proceeding.", {
          containerId: "B",
          type: toast.TYPE.ERROR,
        });
        return;
      }

      // Validate that all selected participants have a type assigned
      const participantsWithoutType = activeEventParticipants.filter(
        p => !participantTypes[p.participant_id] || participantTypes[p.participant_id] === ''
      );
      
      if (participantsWithoutType.length > 0) {
        const namesWithoutType = participantsWithoutType.map(p => 
          p.participate_first_name || p.first_name || 'Unknown'
        ).join(', ');
        
        toast(
          `Please select participant type for: ${namesWithoutType}`,
          {
            containerId: "B",
            type: toast.TYPE.ERROR,
          }
        );
        return;
      }

      let _allEvents = [...eventsData];
      _allEvents = _allEvents.map((eg) => eg.arr_cart).flat();
      const _event = _allEvents.find((e) => e.event_id === active);

      if (!_event) {
        toast("Event data was lost. Please select the event again and try booking.", {
          containerId: "B",
          type: toast.TYPE.ERROR,
        });
        
        // Redirect back to events page after 2 seconds
        setTimeout(() => {
          history.push('/events');
        }, 2000);
        return;
      }

      // Save participant associations (booking will be created at checkout)
      const nodeApiBase = myConstClass.NODE_API_BASE || BASE_URL.replace('/index.php/', '/api');

      if (user_id && user_id > 0) {
        // Logged-in user flow - save participant associations using Node API
        let fetchUrl = "";
        
        if (_event.schedule_id) {
          fetchUrl = `${nodeApiBase}/participants/addScheduleParticipants/${schedule_id}/${user_id}`;
        } else if (_event.event_id) {
          fetchUrl = `${nodeApiBase}/participants/addMachineTestParticipants/${event_id}/${user_id}`;
        }

        // Node API expects array of participant IDs
        const payload = activeEventParticipants.map((el) => el.participant_id);

        if (fetchUrl) {
          const saveParticipantsData = await fetch(fetchUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          });
          
          const saveResult = await saveParticipantsData.json();

          if (saveResult.status !== "true" && saveResult.status !== true) {
            toast("" + (saveResult?.message || "Failed to save participants"), {
              containerId: "B",
              type: toast.TYPE.ERROR,
            });
            return;
          }
        }
        
        // Store participant types AND participant IDs for checkout
        // IMPORTANT: Clear any old data first to avoid stale selections
        const participantTypesData = {};
        const selectedParticipantIds = [];
        
        activeEventParticipants.forEach(p => {
          if (!p.participant_id) {
            return;
          }
          participantTypesData[p.participant_id] = participantTypes[p.participant_id] || 'adult';
          selectedParticipantIds.push(p.participant_id);
        });
        
        // Store only the currently selected participants (replaces old data)
        localStorage.setItem('selected_participant_types', JSON.stringify(participantTypesData));
        
        // Store selected participant IDs for the specific event/schedule
        const eventKey = _event.schedule_id ? `schedule_${schedule_id}` : `event_${event_id}`;
        const loggedInEventParticipants = JSON.parse(localStorage.getItem('logged_in_event_participants') || '{}');
        
        // Replace old selection for this event with current selection
        loggedInEventParticipants[eventKey] = selectedParticipantIds;
        localStorage.setItem('logged_in_event_participants', JSON.stringify(loggedInEventParticipants));
        
      } else {
        // Guest user flow - save participant-event relationship to localStorage
        const guestEventParticipants = JSON.parse(localStorage.getItem('guest_event_participants') || '{}');
        
        // Determine which event we're working with
        const eventKey = _event.schedule_id ? `schedule_${schedule_id}` : `event_${event_id}`;
        
        // Save the participants for this event
        guestEventParticipants[eventKey] = activeEventParticipants.map(p => ({
          participant_id: p.participant_id,
          first_name: p.participate_first_name || p.first_name || '',
          middle_name: p.participate_middle_name || p.middle_name || '',
          last_name: p.participate_last_name || p.last_name || '',
          date_of_birth: p.birth_date || p.date_of_birth || '',
          age: p.participate_age || p.age || 0,
          gender: p.participate_gender || p.gender || '',
          mobile: p.participate_mobile || p.mobile || '',
          email: p.participate_email || p.email || '',
          address: p.participate_address || p.address || '',
          participant_type: participantTypes[p.participant_id] || ''
        }));
        
        localStorage.setItem('guest_event_participants', JSON.stringify(guestEventParticipants));
      }

      // Mark that user is proceeding to next step (not backing out)
      // This prevents events from being removed when navigating to address page
      localStorage.setItem('event_checkout_proceeding', 'true');
      
      // Show modal and proceed
      setShowModal(true);
    } catch (error) {
      toast("Error processing participants. Please try again.", {
        containerId: "B",
        type: toast.TYPE.ERROR,
      });
    }
  }

  const handleDateChange = (date) => {
    setDateOfBirth(date);
    // Validate age when date changes
    validateAge(date);
  };

  // Get the price per person for display
  const getPricePerPerson = (event) => {
    return parseFloat(event?.price) || 0;
  };

  // Display-only date formatter for Accordion header
  const formatEventDateRange = (startDate, endDate) => {
    if (!startDate) return "";

    const formatSingle = (dateStr) => {
      const date = new Date(dateStr);
      if (isNaN(date)) return "";
      return date.toLocaleDateString("en-GB", {
        weekday: "short",
        day: "numeric",
        month: "short",
      });
    };

    // Single-day event
    if (!endDate || startDate === endDate) {
      return formatSingle(startDate);
    }

    // Multi-day event
    return `${formatSingle(startDate)} – ${formatSingle(endDate)}`;
  };


  useEffect(() => {
    setIsAgreed(tncEventsChecked);
  }, [tncEventsChecked]);

  // Calculate price based on participant types and event pricing structure
  const calculatePriceByParticipantType = useCallback((participants, participantTypesMap, eventData) => {
    if (!participants || participants.length === 0) {
      return 0;
    }

    if (!eventData) {
      return 0;
    }

    const firstPriceFor = (eventData.first_price_for || 'person').toLowerCase();
    const secondPriceFor = eventData.second_price_for ? eventData.second_price_for.toLowerCase() : null;
    const firstPrice = parseFloat(eventData.price || 0);
    const secondPrice = parseFloat(eventData.child_price || eventData.price || 0);

    let firstTypeCount = 0;
    let secondTypeCount = 0;
    let unspecifiedCount = 0;

    // Count participants by type
    participants.forEach(participant => {
      const participantId = participant.participant_id;
      const type = (participantTypesMap[participantId] || '').toLowerCase();
      
      if (!type) {
        unspecifiedCount++;
      } else if (type === firstPriceFor) {
        firstTypeCount++;
      } else if (secondPriceFor && type === secondPriceFor) {
        secondTypeCount++;
      } else {
        // If type doesn't match event's pricing types, default to first price
        firstTypeCount++;
      }
    });

    // Special handling for couple: 2 couple participants = 1 price unit
    let firstPriceUnits = firstTypeCount;
    let secondPriceUnits = secondTypeCount;
    
    if (firstPriceFor === 'couple') {
      firstPriceUnits = Math.ceil(firstTypeCount / 2);
    }
    
    if (secondPriceFor === 'couple') {
      secondPriceUnits = Math.ceil(secondTypeCount / 2);
    }

    // Calculate total price
    const firstTotal = firstPriceUnits * firstPrice;
    const secondTotal = secondPriceUnits * secondPrice;
    const unspecifiedTotal = unspecifiedCount * firstPrice; // Default unspecified to first price
    const totalPrice = firstTotal + secondTotal + unspecifiedTotal;

    return totalPrice;
  }, []);

  // NEW: Calculate price dynamically based on number of participants and their types
  useEffect(() => {
    if (!eventsData.length) {
      setCalculatedEventPrice(0);
      return;
    }
    
    let _allEvents = [...eventsData];
    _allEvents = _allEvents.map((eg) => eg.arr_cart).flat();
    const _currentEvent = _allEvents.find((e) => e.event_id === active) || _allEvents[0];
    
    if (_currentEvent) {
      // Get the price per person from the event
      const pricePerPerson = parseFloat(_currentEvent.price) || 0;
      setEventPricePerPerson(pricePerPerson);
      
      // Calculate total based on participant types and event pricing structure
      const totalCalculatedPrice = calculatePriceByParticipantType(
        activeEventParticipants,
        participantTypes,
        _currentEvent
      );
      
      setCalculatedEventPrice(totalCalculatedPrice);
      
      // Update booking_event with the calculated participant counts by type
      const user_id = localStorage.getItem('user_id');
      const bookingKey = (user_id && user_id > 0) ? 'booking_event' : 'booking_event_guest';
      const bookingEventStr = localStorage.getItem(bookingKey);
      
      if (bookingEventStr) {
        const bookingEvent = JSON.parse(bookingEventStr);
        
        // Count participants by their selected type
        const firstPriceFor = (_currentEvent.first_price_for || 'person').toLowerCase();
        const secondPriceFor = _currentEvent.second_price_for ? _currentEvent.second_price_for.toLowerCase() : null;
        
        let firstTypeCount = 0;
        let secondTypeCount = 0;
        
        activeEventParticipants.forEach(participant => {
          const participantId = participant.participant_id;
          const type = (participantTypes[participantId] || '').toLowerCase();
          
          if (type === firstPriceFor) {
            firstTypeCount++;
          } else if (secondPriceFor && type === secondPriceFor) {
            secondTypeCount++;
          } else {
            // If type doesn't match or is unspecified, default to first type
            firstTypeCount++;
          }
        });
        
        // Update parent and child counts based on pricing structure
        // For pricing types like 'couple' we need to store price "units",
        // e.g. 2 participants = 1 couple unit. Checkout uses these units
        // (`booking_event.parent` / `booking_event.child`) to compute totals.
        let firstTypeUnits = firstTypeCount;
        let secondTypeUnits = secondTypeCount;

        if (firstPriceFor === 'couple') {
          firstTypeUnits = Math.ceil(firstTypeCount / 2);
        }
        if (secondPriceFor === 'couple') {
          secondTypeUnits = Math.ceil(secondTypeCount / 2);
        }

        bookingEvent.parent = firstTypeUnits;
        bookingEvent.child = secondTypeUnits;
        bookingEvent.calculated_total = totalCalculatedPrice;
        
        localStorage.setItem(bookingKey, JSON.stringify(bookingEvent));
        
      }
    }
  }, [activeEventParticipants, eventsData, active, participantTypes, calculatePriceByParticipantType]);

  return (
    <>
      <ToastContainer />
      <NewHeader />

      {/* <pre className="mt-5">
        {JSON.stringify(
          {
            active,
            event_id,
            schedule_id,
            isParticipantsSelected,
            activeEventParticipants,
          },
          null,
          2
        )}
      </pre> */}

      <div className="stepper-wrapper mt-1">
        <Stepper steps={checkoutSteps} currentStep={stepsEnum[1]} />
      </div>

      <div className="container container-xl mb-3">
        <Accordion
          activeKey={active}
          onSelect={(e) => {
            setActive(e);
          }}
        >
          {eventsData?.map((eventGroup) => (
            <>
              {eventGroup.arr_cart?.map((event) => (
                <>
                  <Accordion.Item
                    key={event.event_id}
                    eventKey={event.event_id}
                    className="mb-1"
                  >
                    <Accordion.Header>
                       <div className="event-header-row">
                          {/* LEFT: Event title */}
                          <div className="event-title-wrap">
                            <h5 className="event-title">
                              <b>{event.title}</b>
                            </h5>
                          </div>

                          {/* RIGHT: Date + Location */}
                          <div className="event-meta">
                            {(event.start_date || event.end_date) && (
                              <span className="event-meta-item">
                                <i className="fas fa-calendar-alt"></i>
                                <span>
                                  {formatEventDateRange(event.start_date, event.end_date)}
                                </span>
                              </span>
                            )}

                            {(event.venue_address || event.venue) && (
                              <span className="event-meta-item">
                                <i className="fas fa-map-marker-alt"></i>
                                <span>{event.venue_address || event.venue}</span>
                              </span>
                            )}
                        </div>
                      </div>
                    </Accordion.Header>

                    <Accordion.Body style={{padding: '0.5rem 0.75rem 0.25rem 0.75rem'}}>
                      <div className="row no-gutter d-flex align-items-stretch">
                        <Form
                          onSubmit={saveParticipant}
                          className="col-md-6 col-12"
                        >
                          <h5 className="mb-3" style={{fontSize: '1rem'}}>Add new Participant</h5>
                          <Form.Group controlId="formName">
                            {/* <Form.Label className="mb-1">
                              Full Name
                              <span className="red-asterisk fw-bold">*</span>
                            </Form.Label> */}
                            <Form.Control
                              type="text"
                              value={fullName}
                              placeholder="Enter Full Name *"
                              className="mb-3 mt-0"
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                // Allow letters, spaces, and dots (periods)
                                const nameRegex = /^[A-Za-z\s.]+$/;
                                if (
                                  inputValue === "" ||
                                  nameRegex.test(inputValue)
                                ) {
                                  setFullName(inputValue);
                                }
                              }}
                              required
                            />
                            {fullName !== "" &&
                              !/^[A-Za-z\s.]+$/.test(fullName) && (
                                <Form.Text className="text-danger">
                                  Enter a valid Full Name (letters, spaces, and periods only).
                                </Form.Text>
                              )}
                          </Form.Group>

                          <Form.Group controlId="formGender">
                            {/* <Form.Label className="mb-1">
                              Gender<span class="red-asterisk fw-bold">*</span>
                            </Form.Label> */}
                            <Form.Control
                              as="select"
                              value={gender}
                              required
                              className="mb-3 mt-0"
                              onChange={(e) => {
                                setGender(e.target.value);
                              }}
                            >
                              <option value="">Select Gender *</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                            </Form.Control>
                          </Form.Group>

                          {/* <CustomDatePicker
                            label="Date Of Birth (Optional, but please fill for children)"
                            selectedDate={date_of_birth}
                            onDateChange={handleDateChange}
                            formSubmitted={formSubmitted}
                          />
                           */}

                          <Form.Group controlId="formDOB" className="mb-4">
                            <Form.Label className="mb-1">
                              Date of Birth
                              {minAge !== null && maxAge !== null && !(minAge === 0 && maxAge === 0) && (
                                <span className="text-muted" style={{fontSize: '0.85em', marginLeft: '8px'}}>
                                  (Age range: {minAge} - {maxAge} years)
                                </span>
                              )}
                            </Form.Label>
                            <div className="form-control">
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <div
                                  onKeyDownCapture={(e) => {
                                    // Capture Enter before the DatePicker input handles it.
                                    // Prevent default (which was selecting today's date)
                                    // and open the picker instead.
                                    if (e.key === 'Enter') {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      setDobOpen(true);
                                    }
                                  }}
                                >
                                  <DatePicker
                                    disableFuture
                                    className="w-100"
                                    openTo="year"
                                    format="dd/MM/yyyy"
                                    id="birth_date"
                                    name="birth_date"
                                    placeholder="dd/mm/yyyy"
                                    views={["year", "month", "date"]}
                                    value={dateOfBirth}
                                    onChange={handleDateChange}
                                    open={dobOpen}
                                    onOpen={() => setDobOpen(true)}
                                    onClose={() => setDobOpen(false)}
                                  />
                                </div>
                              </MuiPickersUtilsProvider>
                            </div>
                            {ageValidationError && dateOfBirth && (
                              <Form.Text className="text-danger" style={{display: 'block', marginTop: '5px'}}>
                                {ageValidationError}
                              </Form.Text>
                            )}
                          </Form.Group>

                          <div className="mb-4">
                            <button
                              type="submit"
                              className="btn px-5 py-2 add-person-btn"
                              disabled={!enableSave}
                            >
                              Save
                            </button>
                          </div>
                        </Form>

                        <div className="col-md-6 col-12">
                          <h5 className="mb-3" style={{fontSize: '1rem'}}>
                            Saved Participants
                            <span className="text-muted" style={{fontSize: '0.8em', marginLeft: '10px'}}>
                              ({activeEventParticipants.length} selected)
                            </span>
                          </h5>

                          <ListGroup className="masterList">
                            {persons.map((person, index) => {
                              // Check if participant is within age range
                              if (!person || !person.participant_id) {
                                return null;
                              }
                              
                              const isAgeValid = minAge === null || maxAge === null || validateParticipantAge(person);
                              const birthDate = person.birth_date || person.birthDate || person.date_of_birth;
                              const age = birthDate ? calculateAgeInYears(birthDate) : null;
                              const participantType = participantTypes[person.participant_id] || '';
                              
                              return (
                                <ListGroup.Item
                                  key={index}
                                  className={`p-1 border ${!isAgeValid ? 'bg-light' : ''}`}
                                  onClick={(e) => {
                                    // Prevent click on ListGroup.Item from interfering with select dropdown
                                    if (e.target.tagName === 'SELECT' || e.target.closest('select')) {
                                      e.stopPropagation();
                                    }
                                  }}
                                >
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="custom-control position-static custom-checkbox flex-grow-1">
                                      <input
                                        id={person.participant_id}
                                        type="checkbox"
                                        className="custom-control-input"
                                        checked={activeEventParticipants.some(
                                          (activePerson) =>
                                            activePerson.participant_id ===
                                            person.participant_id
                                        )}
                                        disabled={!isAgeValid}
                                        onChange={(e) => {
                                          handlePersonSelect(
                                            person,
                                            e.target.checked
                                          );
                                        }}
                                      />
                                      <label
                                        htmlFor={person.participant_id}
                                        className={`custom-control-label ${!isAgeValid ? 'text-muted' : ''}`}
                                      >
                                        <div>
                                          <b>{person.first_name || person.participate_first_name}</b>,{" "}
                                          <small>{person.gender || person.participate_gender}</small>
                                          <small className="d-block text-muted" style={{fontSize: '0.85em'}}>
                                            Age: {person.age || person.participate_age}
                                          </small>
                                          {!isAgeValid && minAge !== null && maxAge !== null && !(minAge === 0 && maxAge === 0) && (
                                            <small className="text-danger d-block" style={{fontSize: '0.85em', marginTop: '2px'}}>
                                              Age {age !== null ? age : 'unknown'} is outside range ({minAge}-{maxAge} years)
                                            </small>
                                          )}
                                        </div>
                                      </label>
                                    </div>
                                    <div 
                                      className="ml-3" 
                                      style={{minWidth: '150px'}}
                                      onClick={(e) => e.stopPropagation()}
                                      onMouseDown={(e) => e.stopPropagation()}
                                    >
                                      <Form.Control
                                        as="select"
                                        value={participantType}
                                        onChange={(e) => {
                                          try {
                                            e.stopPropagation();
                                            
                                            const participantId = person?.participant_id;
                                            if (!participantId) {
                                              return;
                                            }
                                            
                                            const selectedValue = e.target.value;
                                            
                                            // Use functional update to ensure we have the latest state
                                            setParticipantTypes(prev => {
                                              if (!prev || typeof prev !== 'object') {
                                                return { [participantId]: selectedValue };
                                              }
                                              return {
                                                ...prev,
                                                [participantId]: selectedValue
                                              };
                                            });
                                          } catch (error) {
                                            // Don't let the error propagate
                                          }
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                        }}
                                        onMouseDown={(e) => {
                                          e.stopPropagation();
                                        }}
                                        className="form-control-sm"
                                      >
                                        <option value="">Select Type</option>
                                        {availableParticipantTypes.map(type => (
                                          <option key={type.value} value={type.value}>
                                            {type.label}
                                          </option>
                                        ))}
                                      </Form.Control>
                                    </div>
                                  </div>
                                </ListGroup.Item>
                              );
                            })}
                          </ListGroup>

                          <div className="my-3 d-flex justify-content-start align-items-center flex-wrap">
                            {(() => {
                              const user_id = localStorage.getItem("user_id");
                              // Only show Edit/Delete link for logged-in users
                              if (user_id && user_id > 0) {
                                return (
                                  <Link 
                                    to="/participants" 
                                    className="btn btn-link"
                                    onClick={() => {
                                      // Set flag to indicate user is editing participants
                                      // This prevents cleanup from removing booking_event
                                      localStorage.setItem('editing_participants', 'true');
                                    }}
                                  >
                                    Edit/Delete Participants
                                  </Link>
                                );
                              }
                              return null;
                            })()}
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </>
              ))}
            </>
          ))}
        </Accordion>
      </div>

      <div ref={bottomSummaryRef}>
        <FixedBottomSummary totalPrice={calculatedEventPrice}>
          <div>
            <button
              className="w-100 btn py-2 proceed-button text-nowrap"
              onClick={handleProceed}
              disabled={activeEventParticipants.length === 0}
            >
              <span className="mr-1 fw-bold">Next</span>
              <i className="fas fa-chevron-right fw-bold"></i>
            </button>
          </div>
        </FixedBottomSummary>
      </div>

      <Footer />

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        className="modal-box"
      >
        <Modal.Header>
          <Modal.Title>Instructions</Modal.Title>
          <CloseButton
            className="btn-sm"
            onClick={() => {
              setShowModal(false);
            }}
          ></CloseButton>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <div>
            <b>
              Very Important Instructions for Events (Please download & read the
              pdf to avoid inconvenience){" "}
            </b>
            <br />

            <ul className="pl-3">
              <li>
                Arrival for Course at Lonavla by 9.00 am. Vehicle available for
                Trains from Mumbai: Indrayani, Intercity, Deccan Express & local
                train from Pune at 9:30 am outside platform no.1 (Lonavla West).
                Courses end by 4.30 pm to 5.00 pm, Vehicle is available to
                Railway or Bus station.
              </li>
              <li>
                For Residential Courses, Do pack separate bags (with clothing,
                tooth paste-brush, soap, oil etc.) for children and parents.
                Lodging for boys, girls, men, women parents is separate
                (Exception Mendu-Kranti small kids). Do carry your medicines
                along. Clinic is available.
              </li>
              <li>
                Do keep your PAN /AADHAR Nos. handy while coming for the course.
              </li>
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <a
            href="/address"
            onClick={() => {
              handleConfirmation();
            }}
            className={" btn btn-primary agree-tc "}
          >
            <span className="me-2 mr-2">
              Download Events Terms & Conditions
            </span>

            <i class="fas fa-file-download"></i>
          </a>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EventDetails;
